import { Outlet } from 'react-router-dom'
import { GlobalNavigation } from './global-navigation'
import { useGlobalChatNotifications } from '@/lib/hooks/use-global-chat-notifications'

export default function Layout() {
  // Subscribe to all conversations for global notifications
  useGlobalChatNotifications()

  return (
    <div className="min-h-screen bg-slate-50">
      <GlobalNavigation />
      <Outlet />
    </div>
  )
}
